module.exports = {"TXTCLI_Satellite_to":{"id":"TXTCLI_Satellite_to","defaultMessage":"Satellit til"}}